import React from "react";
import { FiBriefcase, FiPhone, FiCheckCircle } from "react-icons/fi";

const StatCard = ({ label, value, hint, icon: Icon, accent }) => (
  <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
    <div className="flex items-start justify-between gap-3">
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">{label}</p>
        <p className="mt-1 text-2xl font-bold tabular-nums text-slate-900">{value}</p>
        {hint ? <p className="mt-1 text-xs text-slate-500">{hint}</p> : null}
      </div>
      <span
        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl ${accent}`}
        aria-hidden="true"
      >
        <Icon className="h-5 w-5" />
      </span>
    </div>
  </div>
);

const OrganizationStatsBar = ({ totalElements, activeOnPage, callingOnPage, pageCount, t }) => (
  <div className="mb-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
    <StatCard
      label={t("ccOrgStatTotal")}
      value={totalElements}
      hint={t("ccOrgStatTotalHint")}
      icon={FiBriefcase}
      accent="bg-indigo-50 text-indigo-600"
    />
    <StatCard
      label={t("ccOrgStatActive")}
      value={activeOnPage}
      hint={t("ccOrgStatActiveHint").replace("{count}", String(pageCount))}
      icon={FiCheckCircle}
      accent="bg-emerald-50 text-emerald-600"
    />
    <StatCard
      label={t("ccOrgStatCalling")}
      value={callingOnPage}
      hint={t("ccOrgStatCallingHint").replace("{count}", String(pageCount))}
      icon={FiPhone}
      accent="bg-sky-50 text-sky-600"
    />
  </div>
);

export default OrganizationStatsBar;
